import React from 'react';
import { RiskSeverity, PaymentStatus } from '../../types';
import { getSeverityColor, getStatusColor } from '../../lib/utils';

interface BadgeProps {
    children: React.ReactNode;
    variant?: 'default' | 'severity' | 'status';
    severity?: RiskSeverity;
    status?: PaymentStatus;
    className?: string;
}

export const Badge: React.FC<BadgeProps> = ({
    children,
    variant = 'default',
    severity,
    status,
    className = '',
}) => {
    let colorClass = 'bg-gray-100 text-gray-700';

    if (variant === 'severity' && severity) {
        colorClass = getSeverityColor(severity);
    } else if (variant === 'status' && status) {
        colorClass = getStatusColor(status);
    }

    return (
        <span
            className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${colorClass} ${className}`}
        >
            {children}
        </span>
    );
};
